import { HttpClassBase } from 'common-http/index';

const httpBase = new HttpClassBase();

// 对举报平台和contact us 部分的提交表单请求不做语言参数校验
const ForbidURL = {
  report_platform: '/v1/create',
  contact_us: '/createtechsupport',
};

function judgeDataType(data) {
  return Object.prototype.toString.call(data).slice(8, -1);
}
function isObject(data) {
  return judgeDataType(data) === 'Object';
}
function isArray(data) {
  return judgeDataType(data) === 'Array';
}
function isString(data) {
  return judgeDataType(data) === 'String';
}
function deepEqualToEmpty(res) {
  let flag = false;
  const beObject = isObject(res);
  const beArray = isArray(res);
  const beString = isString(res);
  if (beObject) {
    if (Object.keys(res).length === 0) {
      flag = true;
    } else {
      const keys = Object.keys(res);
      const ObjIndex = keys.findIndex((key) => isObject(res[key]));
      const arrayIndex = keys.findIndex((key) => isArray(res[key]));
      const stringIndex = keys.findIndex((key) => isString(res[key]));
      if (ObjIndex !== -1) {
        const objValue = res[keys[ObjIndex]];
        flag = deepEqualToEmpty(objValue);
      } else if (arrayIndex !== -1) {
        const arrayValue = res[keys[arrayIndex]];
        flag = !(arrayValue.length > 0);
      } else if (ObjIndex === -1 && arrayIndex === -1 && stringIndex !== -1) {
        const stringValue = res[keys[stringIndex]];
        flag = !stringValue;
      }
    }
  }
  if (beArray) {
    flag = !(res.length > 0);
  }
  if (beString) {
    flag = !res;
  }
  return flag;
}
export const checkResData = async ({ res, fullPath, data, options }) => {
  const isEmpty = deepEqualToEmpty(res);
  if (fullPath.includes(ForbidURL.report_platform) || fullPath.includes(ForbidURL.contact_us)) {
    return res;
  }
  if (isEmpty) {
    data?.method === 'get' && data.params?.lang && (data.params.lang = 'en');
    data?.method === 'post' && data.body?.lang && (data.body.lang = 'en');
    try {
      return await httpBase.commonHttpCall({ fullPath, data, options }).then((response) => {
        return response;
      });
    } catch (err) {
      Promise.reject(err);
    }
  } else {
    return res;
  }
};
